import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export default function StickyMobileCTA() {
  const waText = encodeURIComponent(
    "Salve, vorrei un preventivo per un trasloco. Mi potete ricontattare?"
  );
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 safe-bottom bg-white/95 backdrop-blur-xl border-t border-brand-line p-3 flex gap-2 shadow-[0_-10px_30px_-15px_rgba(10,23,31,0.25)]"
    >
      <a
        href={`tel:${SITE.phoneTel}`}
        data-testid="sticky-call-btn"
        className="flex-1 h-12 rounded-full bg-brand-primary text-white flex items-center justify-center gap-2 font-semibold text-sm"
      >
        <Phone className="w-4 h-4" />
        Chiama ora
      </a>
      <a
        href={`https://wa.me/${SITE.whatsapp}?text=${waText}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-btn"
        className="flex-1 h-12 rounded-full bg-[#25D366] text-white flex items-center justify-center gap-2 font-semibold text-sm"
      >
        <MessageCircle className="w-4 h-4" />
        WhatsApp
      </a>
    </div>
  );
}
